import * as Immutable from 'immutable';

const EMPTY_STEP = Immutable.Map();

export const preloadOnboardingSteps = () => Promise.resolve();

export default (stepId) => EMPTY_STEP;
